import { getHttpClient } from './httpClient';

export type StripeEnvironment = 'test' | 'live';
export type SyncAction = 'created' | 'reused' | 'would_create' | 'would_reuse';

export interface CodePlan {
  slug: string;
  name: string;
  monthlyPriceCents: number;
  annualPriceCents: number;
  pricingModel: 'per_team' | 'flat';
}

export interface DbPlan {
  slug: string;
  name: string;
  stripe_product_id: string | null;
  stripe_price_monthly_id: string | null;
  stripe_price_annual_id: string | null;
}

export interface StripeSyncStatus {
  environment: StripeEnvironment;
  codePlans: CodePlan[];
  dbPlans: DbPlan[];
}

export interface PlanSyncResult {
  slug: string;
  productAction: SyncAction;
  productId: string | null;
  monthlyAction: SyncAction;
  monthlyPriceId: string | null;
  annualAction: SyncAction;
  annualPriceId: string | null;
}

export interface SyncResult {
  environment: StripeEnvironment;
  dryRun: boolean;
  plans: PlanSyncResult[];
}

export interface SyncRun {
  id: string;
  triggered_by_admin_id: string;
  triggered_by_email: string;
  environment: StripeEnvironment;
  dry_run: boolean;
  status: 'success' | 'error';
  summary: SyncResult | null;
  error_message: string | null;
  started_at: string;
  finished_at: string | null;
  duration_ms: number | null;
}

export async function getStripeSyncStatus(): Promise<StripeSyncStatus> {
  const { data } = await getHttpClient().get('/api/admin/billing/stripe-sync/status');
  return data;
}

export async function previewStripeSync(): Promise<SyncResult> {
  const { data } = await getHttpClient().post('/api/admin/billing/stripe-sync/preview');
  return data;
}

export async function executeStripeSync(): Promise<SyncResult> {
  const { data } = await getHttpClient().post('/api/admin/billing/stripe-sync');
  return data;
}

export async function listStripeSyncRuns(): Promise<SyncRun[]> {
  const { data } = await getHttpClient().get('/api/admin/billing/stripe-sync/runs');
  return data;
}
